module.exports = __webpack_public_path__ + "static/s2-icons-4654f3fdff009124c502f7e5155ab1dd.png";